var map = {
	"./Skeleton-3D-Model-Rigged-00.jpg": 622,
	"./Skeleton-3D-Model-Rigged-01.jpg": 623,
	"./Skeleton-3D-Model-Rigged-02.jpg": 624,
	"./Skeleton-3D-Model-Rigged-03.jpg": 625,
	"./Skeleton-3D-Model-Rigged-04.jpg": 626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 621;